import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/service-tasks', data)
    .then(response => response.data)
}
function update(data, id) {
  return axios.patch(`/service-tasks/${id}`, data)
    .then(response => response.data)
}

export default {
  save(data, id) {
    return id ? update(data, id) : store(data)
  },
  fetch(id) {
    return axios.get(`/service-tasks/${id}`)
      .then(response => response.data)
  },
  fetchList(params) {
    return axios.get('/service-tasks', { params: params })
      .then(response => response.data)
  },
  destroy(id) {
    return axios.delete(`/service-tasks/${id}`)
  },
  destroyMultiple(ids) {
    return axios.post('service-tasks/batch/destroy', ids)
  },
  fetchStats(params) {
    return axios.get('/service-tasks/stats', { params: params })
      .then(response => response.data)
  },
  updateAssignedTo(data) {
    return axios.post('/service-tasks/batch/assigned-to', data)
  },
  updateOwnerVisible(id, data) {
    return axios.post(`/service-tasks/${id}/visible`, data)
      .then(response => response.data)
  },
  updateOwnerVisibilities(data) {
    return axios.post(`/service-tasks/batch/visible`, data)
      .then(response => response.data)
  },
  updateCategory(id, data) {
    return axios.post(`/service-tasks/${id}/category`, data)
      .then(response => response.data)
  },
  updateCategories(data) {
    return axios.post('/service-tasks/batch/category', data)
      .then(response => response.data)
  },
  markHours(id, data) {
    return axios.post(`/service-tasks/${id}/mark-hours`, data)
      .then(response => response.data)
  },
  finishServiceTask(id, data) {
    return axios.post(`/service-tasks/${id}/finish`, data)
      .then(response => response.data)
  },
  finishServiceTasks(data) {
    return axios.post('/service-tasks/batch/finish', data)
      .then(response => response.data)
  },
  unfinishServiceTask(id) {
    return axios.post(`/service-tasks/${id}/unfinish`)
      .then(response => response.data)
  },
  unfinishServiceTasks(ids) {
    return axios.post(`/service-tasks/batch/unfinish`, ids)
      .then(response => response.data)
  },
  updateRequestStatus(id, data) {
    return axios.post(`/service-tasks/${id}/request-status`, data)
      .then(response => response.data)
  },
  updateRequestStatuses(data) {
    return axios.post(`/service-tasks/batch/request-status`, data)
      .then(response => response.data)
  },
  postWinteringTask(yachtId, data) {
    return axios.post(`/service-tasks/wintering/${yachtId}`, data)
      .then(response => response.data)
  },
  generateReport(yachtId, finishedFrom, finishedTo) {
    return axios.post('/service-tasks/generate-report', {
      yacht_id: yachtId,
      finished_at_from: finishedFrom,
      finished_at_to: finishedTo
    }).then(response => response.data)
  },
  printTasks(taskIds) {
    return axios.post('/service-tasks/print', {
      ids: taskIds
    }).then(response => response.data)
  },
  fetchWorkLogs(serviceTaskId) {
    return axios.get(`/service-tasks/${serviceTaskId}/work-logs`)
      .then(response => response.data)
  },
  addWorkLog(serviceTaskId, data) {
    return axios.post(`/service-tasks/${serviceTaskId}/work-logs`, data)
      .then(response => response.data)
  },
  updatePriority(id, data) {
    return axios.post(`/service-tasks/${id}/priority`, data)
      .then(response => response.data)
  }
}
